import { QBox } from '@qualio/ui-components';
import { FC } from 'react';

import { TrainingAssessmentContainer } from '../../TrainingAssessment/TrainingAssessmentContainer';

import styles from '../DocumentOverview.module.css';

export const TrainingAssessmentTab: FC = () => {
  return (
    <QBox className={`${styles['document-overview__trainingContainer']}`}>
      <TrainingAssessmentContainer />
    </QBox>
  );
};
